import { render, staticRenderFns } from "./Utilities-List-Downtime.vue?vue&type=template&id=6c7e2470"
import script from "./Utilities-List-Downtime.vue?vue&type=script&lang=js"
export * from "./Utilities-List-Downtime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports